/**
 * On articles:
 *
 * 1. Fetch the featured-article-collection section HTML. Parse the HTML.
 * 2. Look for shortcodes in the format [featured-products-x].
 * 3. If a numbered shortcode is found, replace it with the matching div such as "#featured-products-x" from the HTML from step 1.
 */
document.addEventListener('DOMContentLoaded', () => {
  const articlePage = document.querySelector('.template-article');

  if (!articlePage) { return; }

  const sectionId = 'featured-article-collection';
  fetch(`${window.location.pathname}?sections=${sectionId}`)
    .then(response => response.json())
    .then(data => {
      const articleContent = document.querySelector('.page__content-column');

      if (!articleContent) { return; }

      const parser = new DOMParser();
      const featuredArticleCollectionHTML = parser.parseFromString(data[sectionId], 'text/html');

      const contentElements = articleContent.children;

      Array(10).fill(0).forEach((_, index) => {
        const featuredProductsId = `featured-products-${index + 1}`;
        const featuredProductsShortcode = [...contentElements].find(el => el.textContent.includes(`[${featuredProductsId}]`));
        const featuredProductsSection = featuredArticleCollectionHTML.querySelector(`#${featuredProductsId}`);

        if (!featuredProductsShortcode || !featuredProductsSection) { return; }

        featuredProductsShortcode.insertAdjacentElement('afterend', featuredProductsSection);
        featuredProductsShortcode.remove();
      });

      window.theme.featuredCollection();
      articleContent.querySelectorAll('.product-card').forEach(productCard => {
        new window.theme.ProductCard(productCard);
      });
    });
});
